import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import logo from '../../../assets/img/logo.svg';
import { LOCAL_STORAGE_KEYS } from '../../../global/const';
import { LOGOUT } from '../../redux/user/UserActions';

const Header = () => {
  const [dropDownMenu, setDropDownMenu] = useState(false);
  const onDropdownClick = () => setDropDownMenu(!dropDownMenu);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleLogout = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
    navigate('/');
    dispatch({
      type: LOGOUT,
    });
  };

  const handlePasswordChange = () => {
    onDropdownClick();
    navigate('/admin/account/change-password');
  };

  return (
    <header className="header">
      <nav className="navbar navbar-expand-lg px-4 py-3 bg-white shadow">
        <div>
          <button
            className="btn menu-toggle btn-clear p-0 mr-3"
            onClick={() => {
              let data = document.body.classList;
              if (data[0] === 'menu-open') {
                document.body.classList.remove('menu-open');
              } else {
                document.body.classList.add('menu-open');
              }
            }}
          >
            <svg height="24" viewBox="0 -53 384 384" width="24" xmlns="http://www.w3.org/2000/svg">
              <path fill="#212529" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
              <path d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
              <path d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" />
            </svg>
          </button>
          <a href="/admin/dashboard" className="navbar-brand font-weight-bold text-uppercase text-base">
            <img src={logo} width={150} height={46} alt="" />
          </a>
        </div>
        <ul className="ml-auto d-flex align-items-center list-unstyled mb-0">
          <li className={'nav-item ml-auto dropdown ' + (dropDownMenu ? 'show' : '')}>
            <a id="userInfo" href="#!" className="nav-link dropdown-toggle" onClick={onDropdownClick}>
              {user.first_name} {user.last_name}
            </a>
            <div className={'dropdown-menu ' + (dropDownMenu ? 'show' : '')}>
              <a href="#!" className="dropdown-item">
                <strong className="d-block text-uppercase headings-font-family">
                  {user.first_name} {user.last_name}
                </strong>
              </a>
              <div className="dropdown-divider"></div>
              <a href="#!" className="dropdown-item" onClick={handlePasswordChange}>
                Change Password
              </a>
              <a href="#!" className="dropdown-item" onClick={handleLogout}>
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
